/*
 * GTM.js
 *
 * Google Tag Manager consent helper. The GTM container and its Consent Mode
 * default ('denied') are loaded directly in public/index.html — so they work
 * for no-JS visitors (the <noscript> fallback) and run at page parse, before
 * any tag fires. This module only pushes Consent Mode UPDATES once the visitor
 * accepts or withdraws (see Analytics.js). It uses the global `dataLayer`;
 * Firebase Analytics runs on its own isolated `firebaseDataLayer` / `firebaseGtag`.
 */

// Standard gtag shim against the global dataLayer (defined in index.html).
function gtag() {
    window.dataLayer.push(arguments);
}

// Pushes a Consent Mode update after the visitor accepts or withdraws consent.
export const updateGtmConsent = granted => {
    if(!window.dataLayer) {
        return;
    }
    gtag('consent', 'update', {
        ad_storage: granted === true ? 'granted' : 'denied',
        ad_user_data: granted === true ? 'granted' : 'denied',
        ad_personalization: granted === true ? 'granted' : 'denied',
        analytics_storage: granted === true ? 'granted' : 'denied'
    });
    console.info('[GTM] consent updated:', granted === true ? 'granted' : 'denied');
}
